import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["audience", "teams", "onChangeAudience", "onChangeTeams"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useUniqueId from 'hooks/useUniqueId';
import toArray from 'utils/toArray';
import { isValidSetAudience } from 'types/skills';
import FormField, { FormFieldAlignedContent } from 'components/FormField';
import Stack from 'components/Stack';
import RadioButtonOption from 'components/RadioButtonOption';
import ShadedCard from 'components/ShadedCard';
import Button from 'components/Button';
import Text from 'components/Text';
import TeamPickerModal from 'screens/TeamPickerModal';
import TeamsList from './common/TeamsList';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function AudienceTeamOrAllOrNoneField(_ref) {
  var unformattedAudience = _ref.audience,
    teams = _ref.teams,
    onChangeAudience = _ref.onChangeAudience,
    onChangeTeams = _ref.onChangeTeams,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId();
  var audience = unformattedAudience || 'none';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasTeamPickerModal = _useState2[0],
    setHasTeamPickerModal = _useState2[1];
  function handleAudienceChange(e) {
    var value = e.currentTarget.value;
    var newAudience = value === 'none' ? null : value;
    if (isValidSetAudience(newAudience)) {
      onChangeAudience(newAudience);
    }
  }
  var onRemoveTeam = function onRemoveTeam(toRemoveTeamId) {
    var teamsToRemove = teams.filter(function (item) {
      return item.id === toRemoveTeamId;
    });
    if (teamsToRemove) {
      onChangeTeams({
        toRemove: teamsToRemove
      });
    }
  };
  var onSubmitTeams = function onSubmitTeams(_ref2) {
    var toAdd = _ref2.toAdd,
      toRemove = _ref2.toRemove;
    onChangeTeams({
      toAdd: toArray(toAdd),
      toRemove: toArray(toRemove)
    });
    setHasTeamPickerModal(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [/*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
        as: "span",
        label: t('property_audience'),
        labelId: uniqueId
      }, otherProps), {}, {
        children: /*#__PURE__*/_jsxs(Stack, {
          spacing: "xs",
          children: [/*#__PURE__*/_jsx(RadioButtonOption, {
            checked: audience === 'all',
            value: "all",
            id: "can_see_everyone_radiobttn",
            name: "audience",
            onChange: handleAudienceChange,
            label: t('state_everyone')
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            checked: audience === 'teams',
            value: "teams",
            id: "can_see_teams_radiobttn",
            name: "audience",
            onChange: handleAudienceChange,
            label: t('state_selected_teams')
          }), /*#__PURE__*/_jsx(RadioButtonOption, {
            checked: audience === 'none',
            value: "none",
            id: "can_see_no_one_radiobttn",
            name: "audience",
            onChange: handleAudienceChange,
            label: t('state_no_one')
          })]
        })
      })), audience === 'teams' && /*#__PURE__*/_jsx(FormFieldAlignedContent, {
        children: /*#__PURE__*/_jsx(ShadedCard, {
          px: "s",
          py: "xs",
          children: /*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
            as: "span",
            label: t('content_type_team_plural'),
            labelId: uniqueId,
            horizontal: false
          }, otherProps), {}, {
            children: /*#__PURE__*/_jsxs(Stack, {
              spacing: "xs",
              children: [teams.length === 0 ? /*#__PURE__*/_jsx(Text, {
                dimmed: true,
                size: "s",
                children: t('amount_none')
              }) : /*#__PURE__*/_jsx(Stack, {
                spacing: "xs",
                children: teams.length > 0 && /*#__PURE__*/_jsx(TeamsList, {
                  teams: teams,
                  onRemoveTeam: onRemoveTeam
                })
              }), /*#__PURE__*/_jsx(Button, {
                size: "medium",
                icon: "edit",
                onClick: function onClick() {
                  return setHasTeamPickerModal(true);
                },
                children: t('actions_select_teams')
              })]
            })
          }))
        })
      })]
    }), hasTeamPickerModal && /*#__PURE__*/_jsx(TeamPickerModal, {
      defaultSelectedItems: teams,
      onClose: function onClose() {
        return setHasTeamPickerModal(false);
      },
      onSubmit: onSubmitTeams
    })]
  });
}
export default AudienceTeamOrAllOrNoneField;